import { Typography } from '@workspace/ui/common';
import { processHeading } from '@workspace/lib/heading-utils';
import { ProductSlideshowSlide } from '../product-slideshow.types';

interface ProductSlideshowTextSectionProps {
  slide: ProductSlideshowSlide;
}

export function ProductSlideshowTextSection({ slide }: ProductSlideshowTextSectionProps) {
  const headingValue =
    typeof slide.heading === 'string' || typeof slide.heading === 'object' ? slide.heading : undefined;
  const subHeadingValue =
    typeof slide.subheading === 'string' || typeof slide.subheading === 'object' ? slide.subheading : undefined;

  const { text: resolvedHeadingText } = processHeading(headingValue);
  const { text: resolvedSubHeadingText } = processHeading(subHeadingValue);
  const description = typeof slide.description === 'string' ? slide.description : '';

  if (!resolvedHeadingText) {
    return null;
  }

  return (
    <div className="text-container w-full flex flex-col gap-4">
      {resolvedHeadingText && (
        <Typography variant="h2" className=" mb-2 text-left w-full break-words">
          {resolvedHeadingText}
        </Typography>
      )}
      {resolvedSubHeadingText && (
        <Typography variant="h3" className="text-primary mb-4 text-left w-full md:max-w-131 break-words ">
          {resolvedSubHeadingText}
        </Typography>
      )}

      {description && description.length > 0 && (
        <div className="prose prose-lg max-w-none font-openSans">
          <Typography variant="bodyMd" className="mb-4 last:mb-0 ">
            {description}
          </Typography>
        </div>
      )}
    </div>
  );
}
